<template>
  <notes
    description="General Notes related to this Booking"
    :notableEntity="notableEntity"
  />
</template>
<script>
import notes from "@/components/Handi/Notes/Notes";

export default {
  props: {
    booking: Object
  },

  components: {
    notes
  },

  data() {
    return {
      entityType: "booking"
    };
  },

  computed: {
    notableEntity() {
      return {
        entityType: this.entityType,
        entityId: this.booking.id
      };
    }
  }
};
</script>
<style lang="scss" scoped></style>
